export const BASE_URL = '/login';
export const Home_URL = '/app/dashboard/default';
export const BASE_TITLE = ' Welcome| E-Blood Bank';

export const CONFIG = {
  layout: 'vertical',
  collapseMenu: false,
  layoutType: 'menu-dark'
};
